let lastId = 0;

export default function(prefix='id') {
  lastId++;
  const timestamp = Date.now();
  const random = Math.floor(Math.random() * 1000);
  return `${prefix}${lastId}_${timestamp}_${random}`;
}